import { render, staticRenderFns } from "./AddSubscriptionOrderForm.vue?vue&type=template&id=88b6ce74&scoped=true&"
import script from "./AddSubscriptionOrderForm.vue?vue&type=script&lang=ts&"
export * from "./AddSubscriptionOrderForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b6ce74",
  null
  
)

export default component.exports